import { render } from "./Main.vue?vue&type=template&id=30c6bed6&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=30c6bed6&scoped=true&lang=css"

import exportComponent from "H:\\Takahammas\\website\\takahammas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c6bed6"]])

export default __exports__